import type { HTMLAttributes } from 'react';

export function Panel({ className = '', ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={`rounded-md border border-border-subtle bg-surface-2 p-3 ${className}`}
      {...props}
    />
  );
}
